// Layer 3 (Transformations) per the 4-layer architecture: pure data, no
// React, no engine mutations. The demo project list the Home scene and the
// TopBar project switcher both read — a thin projection of the canonical
// PROJECT_TILES seed (shared/project-seed.ts) established in parity.P5.

import { PROJECT_TILES } from '@/versions/v1/shared/project-seed';

export type DemoProject = {
  slug: string;
  name: string;
  description: string;
};

export const DEMO_PROJECTS: DemoProject[] = PROJECT_TILES.map((p) => ({
  slug: p.slug,
  name: p.name,
  description: p.description,
}));

export function projectBySlug(slug: string | undefined): DemoProject {
  return DEMO_PROJECTS.find((p) => p.slug === slug) ?? DEMO_PROJECTS[0];
}
